import React, { useEffect, useMemo, useRef } from 'react';
import Axios from 'axios';
import { History } from 'history';
import withTable, { TableContext } from '../../../hoc/withTable';
import Table from '../../../components/Table';
import TableFilterForm from '../../../forms/TableFilterForm';
import { InputDropdownCourse, InputDropDownTermYear, InputTypeDropdown } from '../../../elements';
import { API_URL } from '../../../../lib/const';
import { Link, match } from 'react-router-dom';
import { PermissionContext } from '../../../../hoc/withPermission';
import formater from '../../common/formater';

export const fetch = async (params : any = {'term_year': undefined }) => {
  if (!params.term_year) {
    params['term_year__current'] = true;
  }

  const response = await Axios.get(`${API_URL}/transfers/applications`, { params })
  return response.data;
};

type TransferApplicationListPageProps = {
  onFilterChange: any,
  history: History,
  match: match<{ token: string }>,
}

const TransferApplicationListPage = ({ onFilterChange, history, match }: TransferApplicationListPageProps) => {
  const redirectLinkSuffix = useMemo(() => {
    if (match.path === '/transferencias/aplicacoes/documental') {
      return 'analise-documental';
    }

    return 'analise-academica';

  }, [match.path])

  // "Aprovação - Coordenação" lista só a fila da Coordenação (no processo por
  // convocação: quem a Secretaria enviou), qualquer que seja o usuário logado.
  const routeFilters = useMemo(() => (
    match.path === '/transferencias/aplicacoes/academico' ? { coordination_queue: true } : {}
  ), [match.path]);

  const formFilters = useRef<any>({});

  useEffect(() => { onFilterChange({ ...formFilters.current, ...routeFilters }) }, [routeFilters]);

  const handleFilterChange = (filters: any) => {
    formFilters.current = filters;
    onFilterChange({ ...filters, ...routeFilters })
  }

  const columns = [
    {
      Header: 'Nome',
      accessor: 'real_name',
      Cell: ({ original }: { original: any }) => {
        return (
          <PermissionContext.Consumer>
            {({ hasPermission }: { hasPermission: (permission: string) => boolean }) => (hasPermission('transfers.view_application_document_approval') || hasPermission('transfers.view_application_academic_approval')) ? (  // FIXME.
              <Link style={{ overflow: 'visible', whiteSpace: 'normal' }}
                to={`/transferencias/aplicacoes/${original.token}/${redirectLinkSuffix}`}
              >
                <p>{original.assumed_name || original.real_name}</p>
                {formater.cpf(original.cpf)}
              </Link>
            ) : (original.assumed_name || original.real_name)}
          </PermissionContext.Consumer>
        );
      }
    },
    {
      Header: 'Curso',
      accessor: 'process.course.name',
      Cell: ({ value, original }: { value: string, original: any }) => (
        <div>
          <p className="m-0">{value}</p>
          <p className="m-0">{original.desired_onboarding.field_step}º Período pleiteado</p>
        </div>
      ),
    },
    {
      Header: 'Classificação',
      accessor: 'classification',
      width: 110,
      Cell: ({ value }: { value: number | null }) => value || '-',
    },
    {
      Header: 'Situação',
      accessor: 'status',
    },
    {
      Header: 'Aprovação Secretaria',
      accessor: 'documentation_step_status',
    },
    {
      Header: 'Aprovação Coordenação',
      accessor: 'academic_step_status',
    },
  ];

  return (
    <section>
      <div className="list-base list-base-width" style={{ height: '100vh' }}>
        <TableFilterForm
          onFilterChange={handleFilterChange}
          title="Aplicações de Transferência"
          defaultFilterFields={[{ name: 'name', label: 'Nome', col: 12 }]}
        >
          <InputDropdownCourse col="6" />
          <InputDropDownTermYear col="6" />
          <InputTypeDropdown
            field="status"
            label="Situação"
            options={[
              'Não preenchido',
              'Preenchendo',
              'Preenchido',
              'Em análise',
              'Com pendências',
              'Aprovado',
              'Reprovado',
              'Eliminado',
            ].map(v => ({ value: v, label: v }))}
            col="6"
          />
        </TableFilterForm>
        <TableContext.Consumer>
          {props => <Table columns={columns} {...props} />}
        </TableContext.Consumer>
      </div>
    </section>
  );
};

export default withTable(fetch)(TransferApplicationListPage);
